// ConfirmDeleteModal.jsx
import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./adultcontentmodal.css";
// import { useTranslation } from "react-i18next";
import i18n from "i18next";

export const showAgeConfirmationModal = (onConfirm, onCancel) => {
  const t = i18n.t.bind(i18n);

  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="custom-modal">
          <h1>{t("age_confirmation")}</h1>
          <p>{t("confirmation")}</p>
          <div className="btn-group">
            <button
              className=" ok-btn"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {t("Ok")}
            </button>
            <button
              className=" cancel-btn"
              onClick={() => {
                if (onCancel) onCancel();
                onClose();
              }}
            >
              {t("cancel")}
            </button>
          </div>
        </div>
      );
    },
  });
};
